import * as LIVR from '../../../../packages/js-validator-livr';
import { TreeToDictionaryConverter } from 'types';
import { LivrValidator } from './livr';
import { ValidationSeverity, ValidationResult, ValidationError } from './validation-result';
import { ValidationConfig, ValidationSeveritySetting } from './validation-config';
import { ValidationUtils } from './validation-utils';

export class ObjectValidator<T> {
  private config: ValidationConfig<T>;

  public constructor(config: ValidationConfig<T>) {
    this.config = config;
  }

  public validate(obj: T): ValidationResult {
    var tree = this.getErrorsTree(obj);
    var converter = new TreeToDictionaryConverter();
    var linear = converter.toDictionary(tree);
    var errors: ValidationError[] = [];

    linear.forEach((p) => {
      errors.push({
        path: p.key,
        code: p.value,
        severity: this.getSeverity(p.key, p.value),
        message: this.config.messageProvider ? this.config.messageProvider.getMessage(obj, p.key, p.value) : '',
      });
    });

    return new ValidationResult(errors);
  }

  private getErrorsTree(obj: any): any {
    var validator: LivrValidator = new LIVR.Validator(this.config.specification);
    if (this.config.additionalRules != null) {
      validator.registerRules(this.config.additionalRules);
    }
    validator.validate(obj);
    return validator.getErrors();
  }

  private getSeverity(path: string, code: string): ValidationSeverity {
    if (this.isPresentInList(this.config.notifications, path, code)) return ValidationSeverity.NOTIFICATION;
    else if (this.isPresentInList(this.config.warnings, path, code)) return ValidationSeverity.WARNING;
    else return ValidationSeverity.ERROR;
  }

  private isPresentInList(list: ValidationSeveritySetting[] | null, path: string, code: string): boolean {
    if (list === null) return false;

    return list.some((s) => this.isSettingMatch(s, path, code));
  }

  private isSettingMatch(setting: ValidationSeveritySetting, path: string, code: string): boolean {
    return setting.path === ValidationUtils.excludeArrayIndexing(path) && setting.code == code;
  }
}
